import { Button, Stack, TextField, Typography } from '@mui/material'
import { useRef, useState } from 'react'
import { useStore } from 'utils/store'

export default function AndreaPassWall() {
  const passRef = useRef(null)
  const [password, setPassword] = useState('')
  const [passMessage, setPassMessage] = useState(null)
  const andreaPassword = useStore(state => state.andreaPassword)

  const submitPassword = () => {
    window.localStorage.setItem('andreaPassword', password)

    if (password === andreaPassword) useStore.setState({ andreaAccess: true })
    else {
      setPassword('')
      setPassMessage('Incorrect password. Please try again.')
      passRef.current.focus()
    }
  }

  return (
    <Stack
      position='fixed'
      width='100%'
      height='100%'
      alignItems='center'
      justifyContent='center'>
      <Stack maxWidth={300} mt={-10} gap={2}>
        <Typography variant='overline'>Provide password for access:</Typography>
        <TextField
          ref={passRef}
          type='password'
          variant='standard'
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        <Button variant='contained' onClick={submitPassword}>
          Submit
        </Button>
        {passMessage && (
          <Typography variant='caption' color='error'>
            {passMessage}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}
